<app-spu-form-wrapper
  data-testid="ordinary-spu-view-form-wrapper"
  [config]="config"
  [editMode]="false"
  [viewMode]="true"
  [showFaq]="true"
></app-spu-form-wrapper>
